import { Check, MapPin } from 'react-feather';
import Tilt from 'react-parallax-tilt';
import classNames from 'classnames';
import Paragraph from '../../Typography/Paragraph';
import Parallax from '../../Animation/Parallax';
var CardSearch = function (_a) {
    var user = _a.user, _b = _a.offset, offset = _b === void 0 ? 20 : _b;
    var maxTiltAngle = 10;
    var rand = Math.random() < 0.5;
    return (<Parallax offset={offset}>
      <Tilt tiltReverse tiltMaxAngleX={maxTiltAngle} tiltMaxAngleY={maxTiltAngle} style={{ transformStyle: 'preserve-3d' }}>
        <a className={classNames('group relative flex h-72 w-72 cursor-pointer flex-col justify-end p-6')} href={user.url}>
          {rand ? (<div className="trans-default absolute -top-8 -right-8 h-36 w-36 origin-bottom-left scale-0 transform-gpu rounded-br-full bg-secondary-01-light lg:group-hover:scale-100 max-lg:hidden"/>) : (<div className="trans-default absolute -top-8 -left-8 h-36 w-36 origin-bottom-right scale-0 transform-gpu rounded-tr-full bg-secondary-02 lg:group-hover:scale-100 max-lg:hidden"/>)}

          <div className="absolute-full z-20 bg-gradient-to-b from-brand-01/0 to-brand-01/75"/>

          {user.programs && (<div className="absolute top-2 left-2 z-20 flex flex-wrap gap-2">
              {user.programs.map(function (program) {
                return (<div className="rounded-full bg-brand-02 py-1 px-2 text-[10px] text-white" key={program.title}>
                    {"".concat(program.label ? program.label + ' ' : '').concat(program.title)}
                  </div>);
            })}
            </div>)}

          <img src={(user === null || user === void 0 ? void 0 : user.avatar_small) ? user === null || user === void 0 ? void 0 : user.avatar_small : user === null || user === void 0 ? void 0 : user.avatar} className="cover-full z-10"/>
          <div className="z-30 flex flex-col" style={{ transform: 'translateZ(24px)' }}>
            <div className="flex flex-wrap items-center gap-2 text-white">
              <div className="flex items-start gap-2 text-lg font-medium">
                {user === null || user === void 0 ? void 0 : user.full_name}
                {(user === null || user === void 0 ? void 0 : user.certified_account) && (<span className="flex-center h-4 w-4 flex-shrink-0 rounded-full bg-alert-success">
                    <Check size={10}/>
                  </span>)}
              </div>
              {(user === null || user === void 0 ? void 0 : user.pronoun) !== '' && (user === null || user === void 0 ? void 0 : user.display_pronoun) && (user === null || user === void 0 ? void 0 : user.full_pronoun) && (<div className="flex-none text-xs">({user === null || user === void 0 ? void 0 : user.full_pronoun})</div>)}
            </div>
            <Paragraph className="clamp-2 mt-3 text-white">{user === null || user === void 0 ? void 0 : user.profile_title}</Paragraph>
            <div className="mt-4 flex items-center gap-1 text-white">
              <MapPin size={16}/>
              <div className="text-sm">{user === null || user === void 0 ? void 0 : user.location.address}</div>
            </div>
          </div>
        </a>
      </Tilt>
    </Parallax>);
};
export default CardSearch;
